import { breakpoints } from './variables';

export const debounce = (callback: (args: unknown) => void, wait: number) => {
  let timerId: ReturnType<typeof setTimeout>;

  return (...args: [unknown]) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
};

export const prefersReducedMotion = () => {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export const isLargeDesktop = () => {
  return window.matchMedia(`(min-width: ${breakpoints.desktop - 1}px)`).matches;
};

export const isTablet = () => {
  return window.matchMedia(`(min-width: ${breakpoints.tablet - 1}px)`).matches;
};

export const getEnvGQLUrl = () => {
  const baseUrl = import.meta.env.VITE_OPTIGRAPHQL_BASE_URL as string;

  if (document?.querySelector('body')?.getAttribute('graph-env') === 'prd') {
    return `${baseUrl}${import.meta.env.VITE_OPTIGRAPHQL_PROD_KEY}`;
  } else if (document?.querySelector('body')?.getAttribute('graph-env') === 'stg') {
    return `${baseUrl}${import.meta.env.VITE_OPTIGRAPHQL_STG_KEY}`;
  } else {
    return `${baseUrl}${import.meta.env.VITE_OPTIGRAPHQL_INTE_KEY}`;
  }
};

export const getDistanceInMiles = (
  lat1: number | undefined,
  lon1: number | undefined,
  lat2: number | undefined,
  lon2: number | undefined
): number | undefined => {
  if (!lat1 || !lon1 || !lat2 || !lon2) return undefined;

  const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

  const R = 3958.8;
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};
